import { Icon, ICONS_ENUM, Button, Typography } from '@sanlam-glacier/app-common/components';
import styles from './DashboardUserHeading.module.scss';
import { Link } from 'react-router-dom';
import { useClientIdFromParams } from 'modules/clients/hooks/useClientIdFromParams';
import { useAtomValue } from 'jotai';
import { selectedClientName } from 'stores/dashboard-store/dashboard-store';

interface DashboardUserHeadingProps {
  type: string;
  user: string;
}

export const DashboardUserHeading = ({ user, type }: DashboardUserHeadingProps) => {
  const handleRefresh = () => {
    window.location.reload();
  };

  const clientId = useClientIdFromParams();
  const clientName = useAtomValue(selectedClientName);

  return (
    <div className={styles.dashboardHeader}>
      <div className={styles.headingAndButtonContainer}>
        {type === 'intermediary' ? (
          <Typography variant={Typography.VARIANT.H3} weight={Typography.WEIGHT.BOLD}>
            Welcome back, {user}
          </Typography>
        ) : (
          <>
            <Typography variant={Typography.VARIANT.H3} weight={Typography.WEIGHT.BOLD}>
              <h1>{clientName ? `${clientName}'s Dashboard` : "Client's Dashboard"}</h1>
            </Typography>
            <Link to={`/clients/${clientId}/client-profile`}>
              <Button
                className={styles.clientButton}
                size={Button.SIZE.SMALL}
                endIcon={<Icon icon={ICONS_ENUM.NAVIGATION_ARROW_FORWARD} />}
              >
                Investment & client information
              </Button>
            </Link>
          </>
        )}
      </div>
      <Button
        className={styles.refreshButton}
        startIcon={<Icon icon={ICONS_ENUM.NAVIGATION_REFRESH} />}
        onClick={handleRefresh}
        size={Button.SIZE.SMALL}
        variant={Button.VARIANT.TERTIARY}
      >
        Refresh all
      </Button>
    </div>
  );
};

export default DashboardUserHeading;
